'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _dofButton = require('../dof-button');

var _dofButton2 = _interopRequireDefault(_dofButton);

var _imgs = require('./imgs');

var _imgs2 = _interopRequireDefault(_imgs);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Types = {
  noNetwork: {
    pic: _imgs2.default['noNetwork'],
    content: '网络异常，请检查您的网络设置'
    // button: '刷新'
  },
  noUpdate: {
    pic: _imgs2.default['noUpdate'],
    content: '当前版本较低',
    desc: '请更新到最新版APP'
  },
  noPage: {
    pic: _imgs2.default['noPage'],
    content: '找不到页面'
  },
  colmo: {
    pic: _imgs2.default['colmo']
  }
};
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: {
    DofButton: _dofButton2.default
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    configuration: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    wrapStyle: Object,
    paddingTop: {
      type: [Number, String],
      default: '-80'
    },
    bgColor: {
      type: String,
      default: ''
    },
    imgStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    type_: function type_() {
      if (this.type) return this.type;
      return this._isColmo ? 'colmo' : 'noPage';
    },
    bgColor_: function bgColor_() {
      if (this.bgColor) return this.bgColor;
      return this._isColmo ? '#151617' : this._isDiablo ? '#101315' : '#ffffff';
    },
    resultType: function resultType() {
      return _extends({}, Types[this.type_] ? Types[this.type_] : {}, this.configuration);
    },
    setPaddingTop: function setPaddingTop() {
      var paddingTop = this.paddingTop;
      return paddingTop + 'px';
    }
  },
  methods: {
    handleTouchEnd: function handleTouchEnd(e) {
      // web上面有点击穿透问题
      var platform = weex.config.env.platform;

      platform === 'Web' && e.preventDefault && e.preventDefault();
    },
    onClick: function onClick() {
      this.$emit('dofResultButtonClicked', _extends({}, this.configuration));
    },
    onSubClick: function onSubClick() {
      this.$emit('dofResultSubButtonClicked', _extends({}, this.configuration));
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-result/index.vue
// module id = 373
// module chunks = 0 1